module.exports = __webpack_public_path__ + "img/inoov2.3326fccb.jpg";